import React, { useState, useEffect } from 'react';
import { Form, Button, Row, Col, Spinner, Card } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { Get, Post, Put } from '../../../../utils/httpProvider';
import { DIEUKIENTOCHUC_API } from '../../../../utils/apiUrl';
import { loaiDanhGiaValue } from '../../../../utils/define';

const DieuKienToChucForm = ({ baoVeCapVienId, readOnly = false, isUserView = false }) => {
    const [saving, setSaving] = useState(false);
    
    const [dieuKienToChucId, setDieuKienToChucId] = useState(null);
    const [ketQua, setKetQua] = useState(loaiDanhGiaValue.dat);
    
    // Thành viên tham gia
    const [soThanhVien, setSoThanhVien] = useState('');
    const [soThanhVienVang, setSoThanhVienVang] = useState('');
    const [isLyDo, setIsLyDo] = useState(true);
    const [ghiChu, setGhiChu] = useState('');

    // Điều kiện khác
    const [isCoThuKy, setIsCoThuKy] = useState(true);
    const [isKhongTanThanh, setIsKhongTanThanh] = useState(true);
    const [soNgay, setSoNgay] = useState('');

    const { data: queryRes, refetch, isLoading } = useQuery(
        ['dieuKienToChucData', baoVeCapVienId], 
        () => Get(`${DIEUKIENTOCHUC_API.GET_BY_BAOVECAPVIEN_ID}/${baoVeCapVienId}`),
        { 
            enabled: !!baoVeCapVienId,
            refetchOnWindowFocus: false 
        }
    );

    useEffect(() => {
        if (queryRes) {
            let item = null;
            if (Array.isArray(queryRes)) {
                item = queryRes[0];
            } else if (queryRes.data && Array.isArray(queryRes.data)) {
                item = queryRes.data[0];
            } else if (queryRes.data?.$values) {
                item = queryRes.data.$values[0];
            } else if (queryRes.data) {
                item = queryRes.data;
            } else {
                item = queryRes;
            }

            if (item && item.id) {
                setDieuKienToChucId(item.id);
                setKetQua(item.ketQua || loaiDanhGiaValue.dat);
                
                setSoThanhVien(item.soThanhVien || '');
                setSoThanhVienVang(item.soThanhVienVang || '');
                setGhiChu(item.ghiChu || '');
                setSoNgay(item.soNgay || '');
                
                if (item.isLyDo !== undefined && item.isLyDo !== null) {
                    setIsLyDo(item.isLyDo);
                }
                
                if (item.isCoThuKy !== undefined && item.isCoThuKy !== null) {
                    setIsCoThuKy(item.isCoThuKy);
                }

                if (item.isKhongTanThanh !== undefined && item.isKhongTanThanh !== null) {
                    setIsKhongTanThanh(item.isKhongTanThanh);
                }
            }
        }
    }, [queryRes]);

    const handleSave = async () => {
        setSaving(true);
        try {
            const payload = {
                BaoVeCapVienId: baoVeCapVienId,
                KetQua: ketQua,
                
                SoThanhVien: soThanhVien ? parseInt(soThanhVien) : null,
                SoThanhVienVang: soThanhVienVang ? parseInt(soThanhVienVang) : null,
                IsLyDo: isLyDo,
                GhiChu: ghiChu || '',

                IsCoThuKy: isCoThuKy,
                IsKhongTanThanh: isKhongTanThanh,
                SoNgay: soNgay ? parseInt(soNgay) : null
            };

            if (dieuKienToChucId) {
                await Put(DIEUKIENTOCHUC_API.UPDATE_ITEM, dieuKienToChucId, { ...payload, Id: dieuKienToChucId });
            } else {
                await Post(DIEUKIENTOCHUC_API.CREATE, null, payload);
            }

            toast.success('Lưu thông tin thành công!');
            await refetch();
        } catch (error) {
            console.error(error);
            toast.error('Có lỗi xảy ra khi lưu kết quả.');
        } finally {
            setSaving(false);
        }
    };

    if (isLoading) return <div className="text-center p-3"><Spinner animation="border" variant="primary" /></div>;

    return (
        <div className="bg-white p-3 rounded">
            <Card className="mb-3 border-info shadow-sm">
                <Card.Header className="bg-info text-white font-weight-bold">1. Thông tin chung</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={12} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Kết quả</Form.Label>
                                <div style={{ pointerEvents: (readOnly || isUserView) ? 'none' : 'auto' }}>
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Đạt"
                                        name="ketQuaDieuKien"
                                        checked={ketQua === loaiDanhGiaValue.dat}
                                        onChange={() => { if (!readOnly && !isUserView) setKetQua(loaiDanhGiaValue.dat); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Không đạt"
                                        name="ketQuaDieuKien"
                                        checked={ketQua === loaiDanhGiaValue.khongDat}
                                        onChange={() => { if (!readOnly && !isUserView) setKetQua(loaiDanhGiaValue.khongDat); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3 border-success shadow-sm">
                <Card.Header className="bg-success text-white font-weight-bold">2. Thành viên tham gia</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={6} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Số thành viên Hội đồng tham dự buổi đánh giã</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={soThanhVien}
                                    onChange={(e) => setSoThanhVien(e.target.value)}
                                    placeholder="Nhập số thành viên..."
                                    disabled={readOnly || isUserView}
                                    className={readOnly || isUserView ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={6} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">2.</span> Số thành viên vắng</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={soThanhVienVang}
                                    onChange={(e) => setSoThanhVienVang(e.target.value)}
                                    placeholder="Nhập số thành viên vắng..."
                                    disabled={readOnly || isUserView}
                                    className={readOnly || isUserView ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>

                        <Col md={12} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">3.</span> Có lý do?</Form.Label>
                                <div style={{ pointerEvents: (readOnly || isUserView) ? 'none' : 'auto' }}>
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Có"
                                        name="isLyDo"
                                        checked={isLyDo === true}
                                        onChange={() => { if (!readOnly && !isUserView) setIsLyDo(true); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Không"
                                        name="isLyDo"
                                        checked={isLyDo === false}
                                        onChange={() => { if (!readOnly && !isUserView) setIsLyDo(false); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                </div>
                            </Form.Group>
                        </Col>

                        <Col md={12} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">4.</span> Ghi chú lý do vắng</Form.Label>
                                <Form.Control
                                    as="textarea"
                                    rows={3}
                                    value={ghiChu}
                                    onChange={(e) => setGhiChu(e.target.value)}
                                    placeholder="Nhập ghi chú..."
                                    disabled={readOnly || isUserView}
                                    className={readOnly || isUserView ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            <Card className="mb-3 border-warning shadow-sm">
                <Card.Header className="bg-warning text-white font-weight-bold">3. Điều kiện khác</Card.Header>
                <Card.Body>
                    <Row>
                        <Col md={6} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">1.</span> Thư ký có tham dự?</Form.Label>
                                <div style={{ pointerEvents: (readOnly || isUserView) ? 'none' : 'auto' }}>
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Có"
                                        name="isCoThuKy"
                                        checked={isCoThuKy === true}
                                        onChange={() => { if (!readOnly && !isUserView) setIsCoThuKy(true); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Không"
                                        name="isCoThuKy"
                                        checked={isCoThuKy === false}
                                        onChange={() => { if (!readOnly && !isUserView) setIsCoThuKy(false); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                </div>
                            </Form.Group>
                        </Col>

                        <Col md={6} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">2.</span> Vắng phản biện/thành viên không tán thành?</Form.Label>
                                <div style={{ pointerEvents: (readOnly || isUserView) ? 'none' : 'auto' }}>
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Có"
                                        name="isKhongTanThanh"
                                        checked={isKhongTanThanh === true}
                                        onChange={() => { if (!readOnly && !isUserView) setIsKhongTanThanh(true); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                    <Form.Check 
                                        inline
                                        type="radio"
                                        label="Không"
                                        name="isKhongTanThanh"
                                        checked={isKhongTanThanh === false}
                                        onChange={() => { if (!readOnly && !isUserView) setIsKhongTanThanh(false); }}
                                        tabIndex={readOnly || isUserView ? -1 : 0}
                                    />
                                </div>
                            </Form.Group>
                        </Col>

                        <Col md={12} className="mb-3">
                            <Form.Group>
                                <Form.Label className="font-weight-bold"><span className="text-danger">3.</span> Số ngày kể từ khi có quyết định thành lập Hội đồng đến ngày bảo vệ</Form.Label>
                                <Form.Control
                                    type="number"
                                    value={soNgay}
                                    onChange={(e) => setSoNgay(e.target.value)}
                                    placeholder="Nhập số ngày..."
                                    disabled={readOnly || isUserView}
                                    className={readOnly || isUserView ? "bg-white" : ""}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
            </Card>

            {!readOnly && !isUserView && (
                <div className="text-right mt-4">
                    <Button variant="success" onClick={() => handleSave()} disabled={saving}>
                        {saving ? <Spinner size="sm" animation="border" className="mr-1" /> : <i className="fas fa-save mr-1"></i>}
                        Lưu thông tin
                    </Button>
                </div>
            )}
        </div>
    );
};

export default DieuKienToChucForm;
